export const CookieNames = {
  accessToken: 'access_token',
  idToken: 'id_token',
};
